












































import Vue from 'vue';
import * as relazioneMedicaResponsabilitaApi from '../../services/relazione-medica-responsabilita-api';
import {
    RelazioneMedicaResponsabilitaListViewModel,
    RelazioneMedicaResponsabilita,
} from '../../types';

import relazioneMedicaResponsabilitaEdit from '@/components/commands/RelazioneMedicaResponsabilitaEdit.vue';

export default Vue.extend({
    components: {},
    props: {
        relazioneMedicaId: { required: true, type: Number },
        assicurato: { default: false },
        label: { required: true },
    },
    data(): RelazioneMedicaResponsabilitaListViewModel {
        return {
            columns: [
                {
                    text: this.$i18n.t('labels.operatore-sanitario'),
                    value: 'operatoreSanitario.displayName',
                    width: 200,
                },
                {
                    text: this.$i18n.t('labels.qualifica'),
                    value: 'operatoreSanitario.qualifica.valore',
                    width: 200,
                },
                {
                    text: this.$i18n.t('labels.percentuale-responsabilita'),
                    value: 'percentualeResponsabilita',
                },
            ],
            dataItems: [],
            selectedItems: [],
            dialog: false,
            editComponent: relazioneMedicaResponsabilitaEdit,
            currentEditId: undefined,
        };
    },
    computed: {
        canDelete(): boolean {
            return this.selectedItems.length > 0;
        },
    },
    methods: {
        async loadData(): Promise<void> {
            this.dataItems = await relazioneMedicaResponsabilitaApi.getByRelazioneMedica(
                this.relazioneMedicaId, this.assicurato
            );
            this.selectedItems = [];
        },
        showDetail(item: RelazioneMedicaResponsabilita) {
            this.currentEditId = item.id;
            this.dialog = true;
        },
        async deleteItems(): Promise<void> {
            if (
                await this.$confirm(
                    this.$t('dialog.default-question').toString(),
                    {
                        title: this.$t('dialog.delete-title').toString(),
                        color: 'secondary',
                        icon: 'mdi-delete',
                    }
                )
            ) {
                await relazioneMedicaResponsabilitaApi.remove(
                    this.selectedItems.map((p) => {
                        return {
                            id: p.id,
                            version: p.version,
                        };
                    })
                );
                await this.loadData();
            }
        },
        getComponentProps() {
            return {
                relazioneMedicaId: this.relazioneMedicaId,
                assicurato: this.assicurato,
                id: this.currentEditId,
            };
        },
        dialogClose() {
            this.currentEditId = undefined;
            this.dialog = false;
        },
    },
    async mounted() {
        await this.loadData();
    },
});
